const moveCarouselButton = () => {
  const carouselButtons = document.querySelector('.carousel-nav');
  const relatedItems = document.querySelector('#related-items');

  if (relatedItems && carouselButtons) {
    relatedItems.appendChild(carouselButtons);
  }

  const arrow = `<svg xmlns="http://www.w3.org/2000/svg" width="20.84" height="14.897" viewBox="0 0 20.84 14.897">
  <path id="Path_92" data-name="Path 92" d="M1.558,7.346,6.892,1.77V20.84H8V1.77l5.334,5.576L14.9,7.331,7.85,0h-.8L0,7.331Z" transform="translate(20.84) rotate(90)" fill="#7e71ff"/>
</svg>`;

  const navPrev = document.querySelector('#relatedNavPrev');
  const navNext = document.querySelector('#relatedNavNext');

  if (navPrev && navNext) {
    navPrev.insertAdjacentHTML('afterend', arrow);
    navNext.insertAdjacentHTML('afterend', arrow);
  }
};

module.exports = { moveCarouselButton };



// WEBPACK FOOTER //
// ./scriptPartials/moveCarouselButtons.js